(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /* Scroll-ის მიმართულება + მობილური მენიუს toggle (მხოლოდ დამატება, სხვა არაფერს ვეხებით) */
  class StickyHeader extends HTMLElement {
    constructor(){ super(); }
    connectedCallback(){
      this.header = document.querySelector('.section-header');
      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      /* mobile drawer <details> – Dawn */
      this.menuDetails = document.getElementById('Details-menu-drawer-header') || document.querySelector('header-drawer details');
      this.onMenuToggle = () => {
        if (!this.header) return;
        if (this.menuDetails && this.menuDetails.open) {
          this.header.classList.add('menu-open');
        } else {
          this.header.classList.remove('menu-open');
        }
      };
      if (this.menuDetails) {
        this.menuDetails.addEventListener('toggle', this.onMenuToggle);
        this.onMenuToggle(); // Theme Editor-ში საწყისი მდგომარეობის სინქი
      }
    }
    onScroll(){
      const st = window.pageYOffset || document.documentElement.scrollTop;
      const threshold = 40; // ამაზე დაბლა მუდამ გამჭვირვალე

      if (!this.header) return;

      if (st <= threshold) {
        this.header.classList.remove('scrolling-up');
      } else if (st < this.currentScrollTop) {
        this.header.classList.add('scrolling-up');    // მხოლოდ ზემოთ აწევისას — ფონი ჩნდება
      } else {
        this.header.classList.remove('scrolling-up'); // ქვემოთ ჩამოწევაზე — გამჭვირვალე
      }

      this.currentScrollTop = st;
    }
    disconnectedCallback(){
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.menuDetails) this.menuDetails.removeEventListener('toggle', this.onMenuToggle);
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
